import { Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { LocationAddModalConfirmed } from '../../../stores/locations/locations.actions';

@Component({
  selector: 'era-location-add-modal',
  templateUrl: './location-add-modal.component.html',
  imports: [ReactiveFormsModule, FormsModule],
})
export class LocationAddModalComponent {
  private readonly store = inject(Store);
  public readonly activeModal = inject(NgbActiveModal);

  public hotelCodeForm: UntypedFormControl = new UntypedFormControl('');

  onSubmit() {
    const hotelCode = this.hotelCodeForm.value;
    if (!hotelCode) {
      return;
    }

    this.hotelCodeForm.reset();
    this.store.dispatch(new LocationAddModalConfirmed({ HotelCode: hotelCode }));
    this.activeModal.close();
  }
}
